import script from "./PersonalfragenForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalfragenForm.vue?vue&type=script&setup=true&lang=js"

import "./PersonalfragenForm.vue?vue&type=style&index=0&id=5d38a398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d38a398"]])

export default __exports__